var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopIcon = function SvgEnvelopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "none",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M13.727 3.473c-.63.492-1.422 1.093-4.211 3.117C8.969 7 7.957 7.902 7 7.902c-.984 0-1.969-.902-2.543-1.312C1.668 4.566.875 3.965.247 3.473c-.11-.082-.247 0-.247.136v5.579C0 9.926.574 10.5 1.313 10.5h11.375c.71 0 1.312-.574 1.312-1.312V3.609c0-.136-.164-.218-.273-.136M7 7c.629.027 1.531-.793 1.996-1.121 3.637-2.625 3.91-2.871 4.73-3.527.165-.11.274-.301.274-.52v-.52A1.33 1.33 0 0 0 12.688 0H1.313C.574 0 0 .602 0 1.313v.519c0 .219.082.41.246.52.82.656 1.094.902 4.73 3.527C5.442 6.207 6.345 7.027 7 7"
  })));
};
export default SvgEnvelopIcon;